var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',{staticStyle:{"min-height":"100vh"}},[_c('a-layout',[_c('a-layout-sider',{staticStyle:{"background":"#fff"},attrs:{"width":"200px"}}),_c('a-layout-content',{staticStyle:{"padding":"0 16px"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }